export default __webpack_public_path__ + "img/b340c42e6fba618296ceea0004bd784c.jpg";